import React from 'react';
import api from '../api';
import icons from '../../../../shared/utils/files/antIcons';
import getMess from '../translations';
import { ItemTypes } from '../../constants/constants';

import { Modal, Typography, Space } from 'antd';

const { Text } = Typography;

const label = 'send';

function handler(apiOptions, actions) {
  const { showDialog, hideDialog, getSelectedResources, rootContainer } = actions;

  const getMessage = getMess.bind(null, apiOptions.locale);

  const rawDialogElement = {
    elementType: 'SendDialog',
    elementProps: {
      onHide: hideDialog,
      rootContainer: rootContainer,
      onSubmit: () => {
        hideDialog();
      },
      headerText: getMessage('sendHeader'),
      cancelButtonText: getMessage('cancel'),
      submitButtonText: getMessage('sendConfirm'),
      selectedFiles: getSelectedResources(),
    },
  };
  showDialog(rawDialogElement);
}

export default (apiOptions, actions) => {
  const localeLabel = getMess(apiOptions.locale, label);
  const { getSelectedResources } = actions;
  return {
    id: label,
    icon: { icon: icons.send },
    label: localeLabel,
    shouldBeAvailable: (apiOptions) => {
      const selectedResources = getSelectedResources();

      return selectedResources.length > 0 && selectedResources.every((f) => f.type === ItemTypes.File);
    },
    availableInContexts: ['toolbar', 'row'],
    handler: () => handler(apiOptions, actions),
  };
};
